import { render, staticRenderFns } from "./ruleModal.vue?vue&type=template&id=00b107d7&scoped=true&"
import script from "./ruleModal.vue?vue&type=script&lang=js&"
export * from "./ruleModal.vue?vue&type=script&lang=js&"
import style0 from "./ruleModal.vue?vue&type=style&index=0&id=00b107d7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b107d7",
  null
  
)

export default component.exports